import { useContext, useEffect, useState } from "react";
import { Box, Typography, Grid, Button, CircularProgress } from "@mui/material";
import { CategoryFrecuents } from "../CategoryFrecuents";
import { Images, SnackSimple } from "../../../../../../../../components";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { ObjectGeneric, onChangeEvent } from "../../../../../../../../utils/types/generals";
import { CategoryInterface, DropListSubCategorie, FormContext, IdSubOptionInterface, SelectedSubcategoryInterface, SubcategoryInterface } from "../../Context";
import { useGetData } from "../../hooks/useGetData";
import MultiSelectSimple from "../../../../../../../../components/dinamicForm/multiSelectSimple";
import { EvidenceStateValue, UserInfo } from "../../Interfaces";
import { Types } from "../../../../../../../../utils/enums";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { Constants } from "../../../../../../../../utils/constants";
import Loader from "../../../../../../../../components/loader";
import { FolioTypeEndPoint } from "../../../../utils/enums/endpointFolioType";
import { FolioType } from "../../../../utils/enums/folioType";
import { EvidencesTypeValueEnum } from "../../../../../../../../utils/enums/evidences";
import NotOption from '../../../../../../../../assets/images/optionGroup.png'
import RecursiveSelect from "../selectRecursive";
import CategoriesAdded from "../categoriesAdded";
import SimpleModal from "../../../../../../../../components/modal/simpleModal";
import { parseDropListHierarchy } from "../../methods";

export const Step1 = ({ onContinue }: { onContinue: () => void }) => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const { areas, departments, loadDepartmentsByArea, getCategoriesByDepartment, getConfig, config, getCorrectiveData, options, isOptionsLoaded, notOptions, fetchFrequentOptions, loaderDetail } = useGetData();
  const { formData, updateFormData, id, isEdit, setIsEdit, configCopy, setConfigCopy } = useContext(FormContext);
  const [selectedCategory, setSelectedCategory] = useState(formData.selectedCategory || null);
  const [selectedSubcategories, setSelectedSubcategories] = useState<SelectedSubcategoryInterface[]>(
    formData.selectedSubcategories?.length ? formData.selectedSubcategories : []
  );
  const [subcategoryText, setSubcategoryText] = useState(formData.subcategoryText || "");
  const [selectedArea, setSelectedArea] = useState<ObjectGeneric | null | undefined>(formData.idSubOption ? null : formData.area);
  const [selectedDepartment, setSelectedDepartment] = useState<ObjectGeneric | null | undefined>(formData.idSubOption ? null : formData.department);
  const [categories, setCategories] = useState<CategoryInterface[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [showConfigWarning, setShowConfigWarning] = useState(false);
  const [hasValidConfig, setHasValidConfig] = useState(true);
  const styles = useStyles();
  const [idSubOption, setIdSubOption] = useState<IdSubOptionInterface | undefined>(formData.idSubOption)
  const [selectedCategorySelect, setSelectedCategorySelect] = useState<CategoryInterface | null>(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState<SubcategoryInterface | null>(null);
  const [selectedDrops, setSelectedDrops] = useState<Record<number, DropListSubCategorie | null>>({});
  const [textValue, setTextValue] = useState("");
  const [categoryAuxiliar, setCategoryAuxiliar] = useState<number | undefined>(undefined)
  const [subCategoryAuxiliar, setSubCategoryAuxiliar] = useState<number | undefined>(undefined)
  const [idEditSelection, setIdEditSelection] = useState<number | undefined>(undefined)
  const [openModal, setOpenModal] = useState<{
    open: boolean
    title: string
    description?: string
    children?: JSX.Element
    removeCancel?: boolean
    method: () => void
  }>({
    open: false,
    title: t('reportFolio.snackbar.areYouSureonDeleteThisFile'),
    description: '',
    method: () => { }
  })

  const checkConfig = async (dataDepartment: ObjectGeneric | null | undefined, area: ObjectGeneric | null | undefined, flag: boolean | undefined) => {
    if (area && dataDepartment) {
      const config = await getConfig(area.id, dataDepartment.value);
      if (!config || (Array.isArray(config) && config.length === 0)) {
        setHasValidConfig(false);
        setShowConfigWarning(true);
        return false;
      }
      if (!!flag) {
        setConfigCopy(
          config.configActionPlanReportFolioEvidenceTypes.filter(
            (item) => item.type === 'CREATE'
          )
        );
        /* setConfigCopy(config.configActionPlanReportFolioEvidenceTypes) */
      }
      //const configExists = config.configActionPlanReportFolioEvidenceTypes && config.configActionPlanReportFolioEvidenceTypes.length > 0;
      const configExists = config.configActionPlanReportFolioEvidenceTypes?.some(
        (item) => item.type === 'CREATE'
      );
      setHasValidConfig(configExists);
      setShowConfigWarning(!configExists);
      return configExists;
    }

    setHasValidConfig(true);
    return true;
  };

  useEffect(() => {

    if (config?.configActionPlanReportFolioEvidenceTypes?.some((item) => item.type === 'CREATE')) {

      const evidenceConfig: { [key: number]: EvidenceStateValue } = {};

      const groupedEvidences = formData.evidencesDataEdit?.reduce((acc: any, item: any) => {
        if (item.evidenceTypeId !== undefined) {
          if (!acc[item.evidenceTypeId]) {
            acc[item.evidenceTypeId] = {};
          }
          acc[item.evidenceTypeId][item.originalname] = { name: item.originalname, progress: false, progressAmount: undefined, upload: false, url: item.url }; // Se usa originalname como clave
        } else if (item.comments && Array.isArray(item.comments)) {
          const commentKey = EvidencesTypeValueEnum.COMMENT;
          if (!acc[commentKey]) {
            acc[commentKey] = {};
          }
          item.comments.forEach((comment: string, index: number) => {
            acc[commentKey][comment] = {
              name: comment,
              url: comment
            };
          });
        }
        return acc;
      }, {});

      const mergeConfigurations = (config1: any, config2: any) => {
        const uniqueMap = new Map();

        config1.forEach((item: any) => {
          uniqueMap.set(item.evidenceType.id, { ...item, required: false });
        });

        config2.forEach((item: any) => {
          uniqueMap.set(item.evidenceType.id, item);
        });

        return Array.from(uniqueMap.values());
      }

      const newConfig = !id ? config.configActionPlanReportFolioEvidenceTypes.filter((item) => item.type === 'CREATE') : mergeConfigurations(configCopy, config.configActionPlanReportFolioEvidenceTypes.filter((item) => item.type === 'CREATE'))
      newConfig.forEach((type: any) => {
        const evidenceType = type.evidenceType;
        const params = type.paramsConfiguration;
        const required = type.required

        evidenceConfig[parseInt(evidenceType.id)] = {
          expanded: false,
          seeFiles: true,
          required: required,
          customeTitle: evidenceType.description || evidenceType.key,
          maxCount: params?.amounts || 10,
          minAmount: type.required ? (params?.min || 1) : 0,
          size: params?.sizes || 5,
          value: !id ? {} : groupedEvidences[evidenceType.id] || {},
          accept: params?.types
            ? params.types.map((t: string) => `.${t}`).join(',')
            : Constants.acceptFile[type.evidenceTypeId.toString()]?.map((t: string) => `.${t}`).join(',')
        };
      });
      updateFormData({
        ...formData,
        evidences: formData.evidences ? formData.evidences : {
          value: evidenceConfig,
          open: false,
          type: {
            equivalence: [],
            accept: '',
          },
        }
      });

    }
  }, [config]);

  useEffect(() => {
    const loadInitialData = async () => {
      if (selectedArea) {
        try {
          await loadDepartmentsByArea(selectedArea);
          if (selectedDepartment) {
            setIsLoadingCategories(true);
            const fetchedCategories = await getCategoriesByDepartment(selectedDepartment.value, FolioTypeEndPoint.PREVENTIVE);
            setCategories(fetchedCategories ?? []);
            //Acá se agregan cuando cambia area o departamento
          }
        } catch (error) {
          console.error('Error loading initial data:', error);
        } finally {
          setIsLoading(false);
          setIsLoadingCategories(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadInitialData();
  }, [selectedArea, selectedDepartment]);

  useEffect(() => {
    if (!id) {
      fetchFrequentOptions();
    }
  }, []);


  const setDateFolio = async () => {
    if (id) {
      const data = await getCorrectiveData(id)
      const groupedData = data?.categories?.reduce((acc, item) => {
        const { categoryId, category, subcategoryId, subcategory, requestText, userAssignId, version } = item;

        // Buscar si la categoría ya existe
        let categoryItem = acc.find(cat => cat.id === categoryId);

        if (!categoryItem) {
          // Si no existe, crearla
          categoryItem = {
            name: category,
            id: categoryId,
            subcategories: []
          };
          acc.push(categoryItem);
        }

        // Verificar si la subcategoría ya existe dentro de la categoría
        const subcategoryExists = categoryItem.subcategories.some(sub => sub.id === subcategoryId);

        // Agregar la subcategoría
        if (!subcategoryExists) {
          categoryItem.subcategories.push({
            categoryId,
            id: subcategoryId,
            name: subcategory,
            requestText,
            supllierId: item.userAssignId, // Cambio de nombre a supllierId
            priority: data?.priority,
            priorityId: data?.priority?.id,
            user: {
              id: userAssignId,
              label: `Usuario ${userAssignId}` // Puedes reemplazarlo con nombre real si está disponible
            },
            version: version
          });
        }

        return acc;
      }, [] as { name: string, id: number, subcategories: any[] }[]);
      updateFormData({
        area: {
          value: String(data?.area?.id),
          label: data?.area?.name,
          id: data?.area?.id
        },
        department: {
          value: String(data?.department?.id),
          label: data?.department?.name
        },
        //categoryIdSelected: data?.categories ? data?.categories[0].categoryId : undefined,
        //selectedCategory: data?.categories ? data.categories[0].category : '',
        categoriesCopy: groupedData,
        selectedSubcategories: data?.categories ?
          data.categories.map(category => ({
            categoryName: category.category,
            idArray: Math.floor(Math.random() * 1000000),
            id: category.subcategoryId,
            name: category.subcategory,
            requestText: category.requestText,
            priority: data.priority,
            priorityId: data.priority?.id,
            textRequest: category.listText,
            user: {
              label: data?.reportFolioUserAssign?.length
                ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}`
                : '',
              id: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
              value: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
            },
            categoryId: category.categoryId,
            dropList: parseDropListHierarchy(category.configAnswer, category.dropDownLinks),
          }))
          : [],
        selectedSubcategoriesCopy: data?.categories ?
          data.categories.map(category => ({
            categoryName: category.category,
            idArray: Math.floor(Math.random() * 1000000),
            id: category.subcategoryId,
            name: category.subcategory,
            requestText: category.requestText,
            priority: data.priority,
            priorityId: data.priority?.id,
            textRequest: category.listText,
            user: data?.reportFolioUserAssign?.length ? {
              label: data?.reportFolioUserAssign?.length
                ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}`
                : '',
              id: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
              value: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
            } : null,
            categoryId: category.categoryId,
            dropList: parseDropListHierarchy(category.configAnswer, category.dropDownLinks),
          }))
          : [],
        selectedUnit: {
          value: String(data?.store?.id),
          label: data?.store?.name,
          extraData: {
            timeZone: {
              code: data?.store?.storeTimeZone.code,
              value: data?.store?.storeTimeZone.value,
              zone: data?.store?.storeTimeZone.zone
            }
          }
        },
        selectedPriority: { value: String(data?.priority?.id), label: data?.priority?.name },
        startDate: dayjs(data?.dateStart).tz(data?.store?.storeTimeZone.code).locale('es'),  //dayjs.utc(response.dateStart).format(Constants.dayjsFormat3)
        endDate: dayjs(data?.dateEnd).tz(data?.store?.storeTimeZone.code).locale('es'),
        //selectedFrecuency:,
        //selectedEvery:,
        executionDate: dayjs(data?.dateStartQuestionnaire).tz(data?.store?.storeTimeZone.code).locale('es'),
        executionEndDate: dayjs(data?.dateEndQuestionnaire).tz(data?.store?.storeTimeZone.code).locale('es'),
        selestedQuestionnarie: { value: String(data?.questionnaireId) },
        notifyAssignment: data?.notified,
        selectedTime: { value: String(data?.timeNotification) },
        selectedProvider: data?.reportFolioUserAssign?.length ? {
          value: String(data?.reportFolioUserAssign?.length ? data?.reportFolioUserAssign[0].id : ''),
          label: data?.reportFolioUserAssign?.length ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}` : ''
        } : null,
        selectedProviderCopy: data?.reportFolioUserAssign?.length ? {
          value: String(data?.reportFolioUserAssign?.length ? data?.reportFolioUserAssign[0].id : ''),
          label: data?.reportFolioUserAssign?.length ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}` : ''
        } : null,
        title: data?.name,
        description: data?.description,
        //subcategoryText: data?.categories ? data?.categories[0].subcategoryText : undefined,
        evidencesDataEdit: data?.evidences,
        flag: true
      });
      setSelectedArea({
        value: String(data?.area?.id),
        label: data?.area?.name,
        id: data?.area?.id
      })
      setSelectedDepartment({
        value: String(data?.department?.id),
        label: data?.department?.name
      })
      //setSelectedCategory(data?.categories ? data.categories[0].category : '')
      setSelectedSubcategories(data?.categories ?
        data.categories.map(category => ({
          categoryName: category.category,
          idArray: Math.floor(Math.random() * 1000000),
          id: category.subcategoryId,
          name: category.subcategory,
          requestText: category.requestText,
          priority: data.priority,
          priorityId: data.priority?.id,
          textRequest: category.listText,
          user: data?.reportFolioUserAssign?.length ? {
            label: data?.reportFolioUserAssign?.length
              ? `${data?.reportFolioUserAssign[0].firstName} ${data?.reportFolioUserAssign[0].lastName}`
              : '',
            id: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
            value: data?.reportFolioUserAssign ? data?.reportFolioUserAssign[0].id : 0,
          } : null,
          categoryId: category.categoryId,
          dropList: parseDropListHierarchy(category.configAnswer, category.dropDownLinks),
        })) : [])
      //setSubcategoryText(data?.categories ? String(data?.categories[0].subcategoryText) : '')
      checkConfig({ value: String(data?.department?.id), label: data?.department?.name }, { value: String(data?.area?.id), label: data?.area?.name, id: data?.area?.id }, true)
    }
  }

  useEffect(() => {
    if (!isEdit && !!id) {
      setDateFolio()
      setIsEdit(true)
    }
  }, [id]);

  const cleanFileds = () => {
    setSelectedCategorySelect(null);
    setSelectedSubcategory(null);
    setSelectedDrops({});
    setTextValue("");
  }

  const handleAreaChange = async (e: onChangeEvent) => {
    const areaId = e.target.value;

    if (idSubOption) {
      setSelectedSubcategories([]);
      setSelectedCategory(null);
      setSubcategoryText("");
      updateFormData({
        selectedCategory: undefined,
        selectedSubcategories: [],
        subcategoryText: "",
        idSubOption: undefined
      });
    }
    setIdSubOption(undefined)
    if (!areaId) {
      setSelectedArea(null);
      setSelectedDepartment(null);
      setCategories([]);
      setSelectedCategory(null);
      setSelectedSubcategory(null)
      setSelectedSubcategories(formData?.selectedSubcategoriesCopy ?? []);
      setSubcategoryText("");
      updateFormData({
        area: null,
        department: null,
        selectedCategory: undefined,
        selectedSubcategories: formData.selectedSubcategoriesCopy ?? [],
        subcategoryText: "",
        evidences: undefined,
        idSubOption: undefined
      });
      return;
    }

    setSelectedArea(areaId);
    setSelectedDepartment(null);
    setCategories([]);
    setSelectedCategory(null);
    setSelectedSubcategory(null)
    setSelectedSubcategories(formData?.selectedSubcategoriesCopy ?? []);
    setSubcategoryText("");
    cleanFileds();
    await loadDepartmentsByArea(areaId);
    updateFormData({
      area: areaId,
      department: null,
      selectedCategory: undefined,
      selectedSubcategories: formData.selectedSubcategoriesCopy ?? [],
      subcategoryText: "",
      evidences: undefined,
      idSubOption: undefined
    });
  };

  const handleDepartmentChange = async (e: onChangeEvent) => {
    const departmentId = e.target.value;
    if (idSubOption) {
      setSelectedSubcategories([]);
      setSelectedCategory(null);
      setSubcategoryText("");
      updateFormData({
        selectedCategory: undefined,
        selectedSubcategories: [],
        subcategoryText: "",
        idSubOption: undefined
      });
    }
    setIdSubOption(undefined)
    if (!departmentId) {
      setCategories([])
      setSelectedDepartment(null);
      setSelectedCategory(null);
      setSelectedSubcategory(null)
      setSelectedSubcategories(formData?.selectedSubcategoriesCopy ?? []);
      setSubcategoryText("");
      updateFormData({
        department: null,
        selectedCategory: undefined,
        selectedSubcategories: formData.selectedSubcategoriesCopy ?? [],
        subcategoryText: "",
        evidences: undefined,
        idSubOption: undefined
      });
      return;
    }

    setSelectedDepartment(departmentId);
    setSelectedCategory(null);
    cleanFileds();
    setSelectedSubcategory(null)
    setSelectedSubcategories(formData?.selectedSubcategoriesCopy ?? []);
    setSubcategoryText("");

    const fetchedCategories = await getCategoriesByDepartment(departmentId.value, FolioTypeEndPoint.PREVENTIVE);
    setCategories(fetchedCategories ?? []);
    //Acá se agregan por departamento

    updateFormData({
      department: departmentId,
      selectedCategory: undefined,
      selectedSubcategories: formData.selectedSubcategoriesCopy ?? [],
      subcategoryText: "",
      evidences: undefined,
      idSubOption: undefined
    });
    checkConfig(departmentId, formData.area, false);
  };

  const transformToDropList = (obj: Record<string, any>): DropListSubCategorie[] => {
    const arr = Object.values(obj);

    if (arr.length === 0) return [];

    const buildNode = (node: any): DropListSubCategorie => ({
      label: node.label,
      value: node.value,
      requestText: node.requestText ?? false,
      textRequest: node.textRequest ?? undefined,
      currentNode: node.currentNode,
      dropList: [],
    });

    let root = buildNode(arr[0]);
    let current = root;

    for (let i = 1; i < arr.length; i++) {
      const nextNode = buildNode(arr[i]);
      current.dropList.push(nextNode);
      current = nextNode;
    }

    return [root];
  };

  const handleAddSubcategory = () => {
    let userInfo: UserInfo | null = null;

    if (!selectedSubcategory || !selectedCategorySelect) return

    if (selectedSubcategory.user) {
      userInfo = {
        label: `${selectedSubcategory.user.firstName} ${selectedSubcategory.user.lastName}`,
        id: selectedSubcategory.user.id,
        value: selectedSubcategory.user.id
      };
    }

    const newSubcategory: SelectedSubcategoryInterface = {
      id: selectedSubcategory.id,
      categoryId: selectedCategorySelect?.id,
      idArray: Math.floor(Math.random() * 1000000),
      name: selectedSubcategory.name,
      categoryName: selectedCategorySelect.name,
      user: userInfo,
      requestText: selectedSubcategory.requestText,
      textRequest: textValue,
      dropList: transformToDropList(selectedDrops)
    };

    setSelectedSubcategories((prev) => [...prev, newSubcategory]);
    setIdSubOption(undefined)
    updateFormData({
      selectedSubcategories: formData.selectedSubcategories ? [...formData.selectedSubcategories, newSubcategory] : [newSubcategory],
      idSubOption: undefined
    });

    cleanFileds();
  };

  const handleEditSubcategory = (id: number) => {

    let userInfo: UserInfo | null = null;

    if (!selectedSubcategory || !selectedCategorySelect) return

    if (selectedSubcategory.user) {
      userInfo = {
        label: `${selectedSubcategory.user.firstName} ${selectedSubcategory.user.lastName}`,
        id: selectedSubcategory.user.id,
        value: selectedSubcategory.user.id
      };
    }

    const updatedSubcategory: SelectedSubcategoryInterface = {
      id: selectedSubcategory.id,
      categoryId: selectedCategorySelect?.id,
      idArray: id,
      name: selectedSubcategory.name,
      categoryName: selectedCategorySelect.name,
      user: userInfo,
      requestText: selectedSubcategory.requestText,
      textRequest: textValue,
      dropList: transformToDropList(selectedDrops)
    };

    setSelectedSubcategories((prev) =>
      prev.map((sub) => (sub.idArray === id ? updatedSubcategory : sub))
    );

    updateFormData({
      selectedSubcategories: formData.selectedSubcategories
        ? formData.selectedSubcategories.map((sub) =>
          sub.idArray === id ? updatedSubcategory : sub
        )
        : [updatedSubcategory],
      selectedSubcategoriesCopy: formData.selectedSubcategoriesCopy
        ? formData.selectedSubcategoriesCopy.map((sub) =>
          sub.idArray === id ? updatedSubcategory : sub
        )
        : [updatedSubcategory],
    });


    cleanFileds();
    setIdEditSelection(undefined)
  };

  const searchCategories = async () => {
    const fetchedCategories = await getCategoriesByDepartment(formData.department?.value, FolioTypeEndPoint.PREVENTIVE);
    setCategories(fetchedCategories ?? []);
    updateFormData({
      categories: fetchedCategories ?? []
    });
    const findCat = fetchedCategories?.find(fec => fec.id == categoryAuxiliar)
    if (findCat) {
      setSelectedCategorySelect({
        id: findCat?.id,
        name: findCat?.name,
        subcategories: findCat?.subcategories
      });
    }
    const findSub = findCat?.subcategories.find(sub => sub.id == subCategoryAuxiliar)
    if (findSub) {
      setSelectedSubcategory({
        id: findSub.id,
        name: findSub.name,
        categoryId: findSub.categoryId,
        requestText: findSub.requestText,
        textRequest: findSub.textRequest,
        text: findSub.text,
        priorityId: findSub.priorityId,
        supplierId: findSub.supplierId,
        priority: findSub.priority,
        user: findSub.user,
        dropList: findSub.dropList
      });
    }
    //Acá vuelven a agregarse
  }

  useEffect(() => {
    if (idSubOption) {
      searchCategories()
    }
  }, [idSubOption])

  const handleOptionSelected = (priorityId: number, areaId: number, areaName: string, departmentId: number, departmentName: string, subcategories: { id: number, name: string, categoryName: string, categoryId: number }[], userAssigned?: number) => {

    setSelectedArea({ id: String(areaId), label: areaName, value: areaId });
    setSelectedDepartment({ id: String(departmentId), label: departmentName, value: departmentId });

    const subcategoriesFormatted = subcategories?.map(sub => ({
      subcategoryId: sub.id,
      subcategory: sub.name,
      category: sub.categoryName,
      categoryId: sub.categoryId
    }));


    setSubCategoryAuxiliar(subcategoriesFormatted[0].subcategoryId)
    setCategoryAuxiliar(subcategoriesFormatted[0].categoryId)

    setSelectedDrops({});
    setTextValue("");

    setIdSubOption({ areaId, departmentId, subcategories: subcategoriesFormatted, userAssigned })

    setSelectedSubcategories([]);

    updateFormData({
      idSubOption: { areaId, departmentId, subcategories: subcategoriesFormatted, userAssigned },
      area: { value: String(areaId), label: areaName, id: areaId },
      department: { value: String(departmentId), label: departmentName, id: departmentId },
      selectedSubcategories: [],
      subcategoryText: "",
      evidences: undefined
    });


    checkConfig({ value: String(departmentId), label: departmentName, id: departmentId }, { value: String(areaId), label: areaName, id: areaId }, false);
  };

  const handleRemoveSelection = (id: number) => {
    setOpenModal((prev) => ({
      ...prev,
      open: true,
      title: t('reportFolio.modal.confirmation'),
      description: t('reportFolio.modal.deleteCategori'),
      method: () => {
        setSelectedSubcategories((prev) => prev.filter(sub => sub.idArray !== id));
        setSubcategoryText("");
        setIdSubOption(undefined)
        updateFormData({
          selectedSubcategories: formData.selectedSubcategories ? formData.selectedSubcategories?.filter(sub => sub.id !== id) : [],
          selectedSubcategoriesCopy: formData.selectedSubcategoriesCopy ? formData.selectedSubcategoriesCopy?.filter(sub => sub.id !== id) : [],
          subcategoryText: "",
          idSubOption: undefined
        });
        handleCloseModal();
        if(id==idEditSelection){
          cleanFileds()
          setIdEditSelection(undefined)
        }
      }
    }))

  };

  const handleEditSelection = (id: number, sub: SelectedSubcategoryInterface) => {
    setIdEditSelection(id)

    const category = categories.find(cat => cat.id === sub.categoryId) || null;
    setSelectedCategorySelect(category);

    const subcategory = category?.subcategories.find(s => s.id === sub.id) || null;
    setSelectedSubcategory(subcategory);

    setTextValue(sub.textRequest ?? '')

    if (!subcategory?.dropList) return;

    const selectedDrops: Record<number, DropListSubCategorie | null> = {};

    const findMatchingDropList = (
      sourceList: DropListSubCategorie[],
      selectedValue: number
    ): DropListSubCategorie | undefined => {
      for (const item of sourceList) {
        if (item.value === selectedValue) return item;
        if (item.dropList?.length) {
          const found = findMatchingDropList(item.dropList, selectedValue);
          if (found) return found;
        }
      }
      return undefined;
    };

    const buildSelectedDrops = (
      editDropList: DropListSubCategorie[],
      sourceDropList: DropListSubCategorie[],
      level = 0
    ) => {
      if (!editDropList || editDropList.length === 0) return;

      const selected = editDropList[0];
      const matched = findMatchingDropList(sourceDropList, selected.value);

      if (matched) {
        const currentOptions = matched.dropList;
        selectedDrops[level] = {
          ...selected,
          dropList: currentOptions,
        };

        if (selected.dropList && selected.dropList.length > 0 && matched.dropList) {
          buildSelectedDrops(selected.dropList, matched.dropList, level + 1);
        }
      }
    };

    buildSelectedDrops(sub.dropList, subcategory.dropList);

    setSelectedDrops(selectedDrops);
  }

  const cacelEdition = () => {
    setIdEditSelection(undefined)
    cleanFileds()
  }

  const handleCloseModal = () => {
    setOpenModal((prev) => ({ ...prev, open: false, }))
  }

  const handleRegresar = () => {
    navigate("/dashboard/report-folio/dashboard");
  };


  const handleContinue = () => {
    if (!idSubOption) {
      if (selectedSubcategories.length === 0) return;

      updateFormData({
        selectedCategory,
        selectedSubcategories,
        area: selectedArea,
        department: selectedDepartment,
        categories,
        subcategoryText
      });

      onContinue();
    } else {
      if (selectedSubcategories.length === 0) return;
      onContinue();
    }
  };

  if (isLoading || loaderDetail) {
    return (<CircularProgress />);
  }

  return (
    <Box mt={2}>

      {isOptionsLoaded ?
        <Loader />
        :
        <>
          {!notOptions && !id ?
            <>
              <Box mb={2}>
                <Typography variant="blue_title">
                  {t("reportFolio.forms.MostFrecuenceSelection")}
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {options.map((option, index) => (
                  <Grid item xl={3} xs={6} sm={6} md={6} key={index} sx={{ display: 'flex' }} >
                    <CategoryFrecuents {...option} onClickPreventive={handleOptionSelected} typeFolio={FolioType.PREVENTIVE} idSubOptionPreventive={idSubOption} />
                  </Grid>
                ))}
              </Grid>
            </>
            :
            <></>
          }
        </>
      }


      <Grid container spacing={2} mt={4}>
        {/* Zona de gestion */}
        <Grid item xl={6} lg={6} md={6} sm={12} xs={12} sx={styles.gestioneZoneBox}>
          <Typography variant="blue_title">{t("reportFolio.forms.classificationOfTheApplication")}</Typography>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <MultiSelectSimple
                isRequired
                name="Area"
                label={"Área *"}
                onChange={handleAreaChange}
                items={areas}
                selected={selectedArea}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <MultiSelectSimple
                isRequired
                name="Departamento"
                label={"Departamento *"}
                onChange={handleDepartmentChange}
                items={departments}
                selected={selectedDepartment}
                disabled={!selectedArea}
              />
            </Grid>
          </Grid>

          {/* Seleccionar categorías y subcategorías */}
          <Box sx={styles.categoryAndSubCategoryGrid}>
            <Box sx={styles.conteinerClear}>
              <Typography variant="blue_title" mb={1}>
                {t("reportFolio.forms.selectCategories")}
              </Typography>

              {selectedCategorySelect && <Button onClick={cleanFileds}>{t('reportFolio.buttons.clearSelection')}</Button>}
            </Box>

            <Box display="flex" flexDirection="column" gap={2}>
              <Box display="flex" alignItems="flex-start" gap={2}>
                <Box display="flex" flexDirection="column" gap={1} sx={{ width: '100%' }}>
                  {isLoadingCategories ? (
                    <CircularProgress />
                  ) : (categories.length === 0 && selectedDepartment ? (
                    <Box sx={{ textAlign: "center", color: "#999", fontStyle: "italic", padding: "8px" }}>
                      {t('reportFolio.detail.general.departmentWithoutCategories')}
                    </Box>
                  ) : (
                    <RecursiveSelect
                      categories={categories}
                      selectedCategorySelect={selectedCategorySelect}
                      selectedDrops={selectedDrops}
                      selectedSubcategory={selectedSubcategory}
                      setSelectedCategorySelect={setSelectedCategorySelect}
                      setSelectedDrops={setSelectedDrops}
                      setSelectedSubcategory={setSelectedSubcategory}
                      setTextValue={setTextValue}
                      textValue={textValue}
                      handleAddSubcategory={handleAddSubcategory}
                      handleEditSubcategory={handleEditSubcategory}
                      cacelEdition={cacelEdition}
                      id={idEditSelection}
                      noDepartment={!selectedDepartment}
                    />
                  ))}
                </Box>

              </Box>
            </Box>

          </Box>
        </Grid>

        <Grid item xl={6} lg={6} md={6} sm={12} xs={12} sx={styles.gestioneZoneBox}>
          <Typography variant="blue_title">
            {t("reportFolio.forms.categoriesSelected")}
          </Typography>
          <Box sx={styles.categoriesSelected}>
            {!selectedSubcategories.length ?
              (
                <Box sx={styles.containerNoCategories}>
                  <Images sx={styles.img} src={NotOption} />
                  <Typography >{t("reportFolio.forms.noCategoriesSelected")}</Typography>
                </Box>
              )
              :
              <CategoriesAdded handleEditSelection={handleEditSelection} handleRemoveSelection={handleRemoveSelection} selectedSubcategories={selectedSubcategories} />
            }
          </Box>
        </Grid>
      </Grid>
      {/* Formulario */}

      <Box sx={styles.btnsContainer}>
        <Button onClick={handleRegresar} sx={styles.btnBack}>
          {t("reportFolio.forms.back")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleContinue}
          sx={{ borderRadius: '4px' }}
          disabled={
            (
              !selectedArea ||
              !selectedDepartment ||
              !categories.length ||
              selectedSubcategories.length === 0 ||
              !hasValidConfig
            )
          }
        >
          {t("reportFolio.forms.continue")}
        </Button>
      </Box>

      <SnackSimple
        open={showConfigWarning}
        close={() => setShowConfigWarning(false)}
        message="Para crear un folio en esta área y departamento, debes crear una configuración."
        type={Types.INFO}
      />

      <SimpleModal
        open={!!openModal.open}
        close={handleCloseModal}
        title={openModal.title}
        description={openModal.description}
        cancelText={t('general.cancel')}
        buttonText={t('general.confirm')}
        back={handleCloseModal}
        next={openModal.method}
      />


    </Box>
  );
};